import { tSyncConversationsContext } from './SyncConversations.types.ts';
import { eIntegrationType } from '../IntegrationsProvider/Integrations.enums.ts';

export const initialState: tSyncConversationsContext = {
  syncConversations: 0,
  setSyncConversations: () => {},
  totalConversations: 0,
  setTotalConversations: () => {},
  conversations: [],
  setConversations: () => {},
  initialProgress: 0,
  setInitialProgress: () => {},
  handles: [],
  setHandles: () => {},
  selectedIntegration: eIntegrationType.WHATSAPP_WEB,
  setSelectedIntegration: () => {},
  selectedPagUUid: '',
  setSelectedPageUuid: () => {},
};
